export default "__VITE_ASSET__cV$t7nLi__"